import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d0e8a4e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0e8a4e')) {
      api.createRecord('3d0e8a4e', component.options)
    } else {
      api.reload('3d0e8a4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d0e8a4e&", function () {
      api.rerender('3d0e8a4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/ip-filter/index.vue"
export default component.exports